import restClient from '../restClient';
export const KEEP_ALIVE_FAILED = 'KEEP_ALIVE_FAILED';
export const keepAliveFailed = error => ({
  error,
  type: KEEP_ALIVE_FAILED
});
export const keepAlive = id => {
  return async dispatch => {
    try {
      await restClient.keepAlive();
    } catch (error) {
      const requestExceptionWithResponse = error;
      dispatch(keepAliveFailed(requestExceptionWithResponse));
      if (requestExceptionWithResponse && requestExceptionWithResponse.status >= 400) {
        clearInterval(id);
      }
    }
  };
};